import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { fetcher } from "@/lib/swr";
import { SWRConfig } from "swr";
import App from "./App";
// @ts-ignore side-effect CSS import has no type declarations
import "./globals.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <SWRConfig
    value={{
      fetcher: fetcher,
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      dedupingInterval: 60000,
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </SWRConfig>
);
